import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from 'src/app';

import 'src/locales/i18n';
import 'src/styles/fonts';
import 'src/styles/styles.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container "#root" was not found in the document');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
